  import styled from "styled-components";
  import helper from "components/utils/helper"
  import { breakpoints } from "themes/breakpoints.theme";
  import ProductColors from "components/common/Colors/ProductColors";


  const GetInvolvedContainer = styled.div`
  position: relative;
  flex-wrap: wrap;
  display: flex;
  @media (min-width: ${breakpoints.lg}) {
    display: flex;
    flex-wrap: nowrap;
    
  }
  `;


  const GetInvolvedBlock = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: column;
  position: relative;
  padding: 40px 16px;
  transition: 0.8s ease-out;
  opacity: 0.2;
    background: transparent;
    > img{
      opacity: 0;
    }
  flex: 100%;
  height: 376px;
  :hover {
    background: ${(props) => (props.color ? props.color : null)};
    opacity: 1;
  }


  @media (min-width: ${breakpoints.sm}) {
    margin: 0;
    flex: 50%;
  }
  @media (min-width: ${breakpoints.sm}) {
    
    padding: 40px 32px;
    transition: 0.2s ease;
    
    :hover{
      > img{
        opacity: 1;
      }
    }
    
      
  }
  @media (min-width: ${breakpoints.lg}) {
    padding: 56px 28px;
    height: 528px;
  }
  @media (min-width: ${breakpoints.sm}) and (max-width: ${breakpoints.md} ){
      ${ (props) =>{
        
        if(helper.isTouchDevice()){
        //workaround for grow
          if(( props.color === ProductColors.Grow || props.color === ProductColors.Move) && props.top < 550 &&  props.top > 250){
              return `
                  background-color: ${props.color};
                  opacity: 1;
                  > img{
                    opacity: 1;
                  }
                `
          }

          //only show bg if on screen
          if(props.forwardedRef && props.forwardedRef.current){
            let cardTop = props.forwardedRef.current.offsetTop
            let cardBottom =  props.forwardedRef.current.offsetHeight + cardTop
    
            if(props.forwardedRef.current.offsetTop > 0){
              
              if( cardTop < props.top  && cardBottom < props.top + 250 && cardBottom > props.top - 250){
                
                return `
                  background-color: ${props.color};
                  opacity: 1;
                  > img{
                    opacity: 1;
                  }
                `
              }
            }
          
            
          }

          }   
      }
      
    }
  }
  
  @media (max-width: ${breakpoints.sm}){
    >img{
      transition: 0.8s ease-out ;
    }
    ${ (props) => { 
      

      //workaround for grow
      if(props.color === ProductColors.Grow && props.top < 750 &&  props.top > 150){
          return `
              background-color: ${props.color};
              opacity: 1;
              > img{
                opacity: 1;
              }
            `
      }

      //only show bg if on screen
      if(props.forwardedRef && props.forwardedRef.current){
        let cardTop = props.forwardedRef.current.offsetTop
        let cardBottom =  props.forwardedRef.current.offsetHeight + cardTop
 
        if(props.forwardedRef.current.offsetTop > 0){
          
          if( cardTop < props.top  && cardBottom < props.top + 250 && cardBottom > props.top - 250){
            
            return `
              background-color: ${props.color};
              opacity: 1;
              > img{
                opacity: 1;
              }
            `
          }
        }
       
        
      }
     
      }
      }; 
    }
  `;

  const GetInvolvedLink = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  z-index: 4;
  color: transparent !important;
  `;

  const GetInvolvedCopy = styled.div`
  text-align: left;
  max-width: 75%;
  @media (min-width: ${breakpoints.md}) {
    max-width: 66%;
  }

  h1 {
    font-family: Anton;
    font-style: normal;
    font-weight: normal;
    margin: 0;
    font-size: 50px;
    line-height: 95%;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    max-width: 200px;
    
  }

  p {
    font-size: 16px;
    font-family: Overpass;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 140%;
    margin: 11px 0;
  }
  `;

  const GetInvolvedCta = styled.a`
  position: relative;
  margin-top: auto;
  margin-bottom: 0;
  margin-right: auto;
  display: inline-block;
  width: auto;
  padding: 9px 18px;
  background: #151515;
  color: #E8E8E8;
  font-size: 14px;
  line-height: 160%;  
  z-index: 5;
  text-decoration: none;

  img {
    height: 10px;
    margin-left: 6px;
  }
  :hover {
    color: #FFFFFF;
    background: #151515;
    text-decoration: none;
  }
  `;

  const GetInvolvedImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
  max-width: 350px;

  `;




  export {
    GetInvolvedContainer,
    GetInvolvedBlock,
    GetInvolvedLink,
    GetInvolvedCopy,
    GetInvolvedImage,
    GetInvolvedCta,
  };
